import {Injectable} from '@angular/core';
import {CommandAction} from '../../../../core/command/commandAction';
import {UrlHelper} from '../../../../../store/core/url/urlHelper';
import {SALE_STATUS} from '../../../../sale/api/entity/sale.model';
import {WorkflowTaskStatus, WorkflowTaskSummaryModel} from '../model/common/workflowTaskSummary.model';

@Injectable({providedIn: 'root'})
export class TaskCommandService {

    constructor() {
    }

    listPage(): CommandAction {
        return new CommandAction('taches', [], undefined, true);
    }

    lateListPage(): CommandAction {
        return new CommandAction('taches',
            UrlHelper.formatInitialFormStateAsQueryParam({
                overdue: true
            }),
            undefined,
            true
        );
    }

    inProgressPage(): CommandAction {
        return new CommandAction('taches', [], undefined, true);
    }

    notStartedPage(): CommandAction {
        return new CommandAction('taches');
    }

    viewTask(task: WorkflowTaskSummaryModel): CommandAction {
        return new CommandAction('taches/' + task.id + '/voir', undefined, undefined, true);
    }
}
